export default "__VITE_ASSET__CrXCv0as__"